export const validateFields = (state, fields) => {
  let errors = [];
  fields.forEach(({ name, validator }) => {
    if (!validator(state[name])) {
      errors.push(name);
      try {
        document
          .querySelector(`input[name="${name}"]`)
          .classList.add("is-invalid");
      } catch (error) {
        console.error(`Erro ao adicionar classe inválida para ${name}:`, error);
      }
    } else {
      try {
        document
          .querySelector(`input[name="${name}"]`)
          .classList.remove("is-invalid");
      } catch (error) {
        console.error(`Erro ao adicionar classe inválida para ${name}:`, error);
      }
    }
  });
  return errors;
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/Client/helpers/index.js